import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex alert alert-danger border border-dashed border-danger border-1 d-flex align-items-start" }
const _hoisted_3 = { class: "svg-icon svg-icon-2hx svg-icon-danger me-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("p", null, "This section is advanced if you don't know about updateauth action please leave this section or ask an expert and trusted person."),
  /*#__PURE__*/_createElementVNode("p", null, "Note: before change the keys be sure you have it's private key."),
  /*#__PURE__*/_createElementVNode("p", null, "Note: beware that the private key owner will have access to your assets, don't add or update the key that you don't know the origin, scammers are everywhere.")
], -1)
const _hoisted_5 = {
  class: "accordion",
  id: "kt_accordion_1"
}
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_AdvanceItem = _resolveComponent("AdvanceItem")!
  const _component_Loading = _resolveComponent("Loading")!

  return (!_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
          ]),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.account.permissions, (permission, index) => {
            return (_openBlock(), _createBlock(_component_AdvanceItem, {
              key: index,
              permission: permission,
              account: _ctx.account,
              accountPermission: _ctx.accountPermission,
              index: index
            }, null, 8, ["permission", "account", "accountPermission", "index"]))
          }), 128))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_Loading)
      ]))
}